// extracted by mini-css-extract-plugin
module.exports = {"col":"_1TCEqpDGo3wGyni9p9Ybcy","iconText":"_203s2Sz93gfr1cTcVVKDg8","container":"_1ViXQdbFOsUpCAevqnBxm1"};